import { Box, Typography, SxProps, Theme } from "@mui/material";
import { CustomSkeleton } from "components/CustomSkeleton";
import React from "react";

type Props = {
  title: string;
  value: string | number | null;
  boxStyle?: SxProps<Theme>;
  titleStyles?: SxProps<Theme>;
  valueStyles?: SxProps<Theme>;
  isLoading?: boolean;
  skeletonStyles?: SxProps<Theme>;
  isLink?: boolean;
};

export const TextGroup = ({
  title,
  value,
  boxStyle,
  titleStyles,
  valueStyles,
  isLoading,
  skeletonStyles,
  isLink,
}: Props) => {
  const currentValue = value || "-";
  const linkPrefix = `${currentValue}`.startsWith("http") ? "" : "//";

  return (
    <Box
      sx={{
        ...boxStyle,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          ...titleStyles,
          mb: "8px",
        }}
      >
        {title}
      </Typography>
      {isLoading ? (
        <CustomSkeleton styles={{ width: "100%", ...skeletonStyles }} />
      ) : isLink && value ? (
        <a
          href={`${linkPrefix}${currentValue}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: "#E1A34B", fontSize: "14px" }}
        >
          {currentValue}
        </a>
      ) : (
        <Typography
          sx={{
            ...valueStyles,
          }}
        >
          {currentValue}
        </Typography>
      )}
    </Box>
  );
};
